import { warn } from '@execonline-inc/logging';
import { assertNever } from '@kofno/piper';
import {
  FilterError,
  FilterOption,
  FilterOptionsResource,
  Filtering,
  Loading,
  NewState,
  State,
  error,
  filtered,
  filtering,
  optionSelected,
} from './Types';

export const setFilteringState =
  (state: State, setState: (value: NewState) => void) => (filterBy: string) => {
    switch (state.kind) {
      case 'ready':
      case 'filtered':
      case 'option-selected':
        setState(filtering(filterBy));
        break;
      case 'loading':
      case 'filtering':
      case 'error':
        break;
      default:
        assertNever(state);
    }
  };

export const setOptionSelectedState =
  (state: State, setState: (value: NewState) => void) => (selectedValue: FilterOption) => {
    switch (state.kind) {
      case 'filtered':
      case 'option-selected':
        setState(optionSelected(selectedValue, state.optionsResource));
        break;
      case 'loading':
      case 'ready':
      case 'filtering':
      case 'error':
        break;
      default:
        assertNever(state);
    }
  };

export const setFilteredState =
  (state: Loading | Filtering, setState: (value: NewState) => void) =>
  (optionsResource: FilterOptionsResource) =>
    setState(filtered(optionsResource, state));

export const warnAndSetErrorState = (setState: (value: NewState) => void) => (e: FilterError) => {
  const message = 'Error loading options';
  warn(message, e);
  setState(error(message));
};
